export class NotAuthenticatedError extends Error {
  constructor() {
    super("Auth user not found.");
    this.name = "NotAuthenticatedError";
  }
}
